import { Brain01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { createFileRoute } from '@tanstack/react-router';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';

import { getDashboardUrl, useDashboardThemeSync } from '@/lib/dashboard-theme';

export const Route = createFileRoute('/_authenticated/reports/ai-builder')({
  component: AiBuilderPage,
});

function AiBuilderPage() {
  const { t } = useTranslation();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const aiBuilderUrl = getDashboardUrl({ dashboard: 'ai-reports', showSidebar: 'false' });

  useDashboardThemeSync(iframeRef);

  return (
    <div className="space-y-4 h-[calc(100vh-2rem)] flex flex-col">
      <div className="flex items-center justify-between flex-shrink-0">
        <div>
          <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
            <HugeiconsIcon icon={Brain01Icon} className="size-6" />
            {t('sidebar.reports.aiBuilder', 'AI Report Builder')}
          </h1>
          <p className="text-muted-foreground text-sm">
            {t(
              'reports.aiBuilder.description',
              'Generate custom reports from natural language prompts using AI',
            )}
          </p>
        </div>
      </div>

      <Card className="flex-1 overflow-hidden min-h-0 py-0">
        <CardContent className="p-0 h-full">
          <iframe
            ref={iframeRef}
            src={aiBuilderUrl}
            className="w-full h-full border-0"
            title="AI Report Builder"
            allow="fullscreen"
          />
        </CardContent>
      </Card>
    </div>
  );
}
